import { MQTT_CONFIG } from "./mqtt.config";

export const environment = {
    production: true,
    APP_HOST: 'https://dev-01.sadinhub.net',
    APP_ENDPOINT: `https://dev-01.sadinhub.net/api/v1/`,
    MQTT_CONFIG: MQTT_CONFIG,
    GOOGLE_MAPS_API_KEY: 'YOUR_PROD_API_KEY_HERE',
};